





































































































































































































import Vue from 'vue';
import utilMethods from '@/services/utils';

interface FilterListData {
  panel: number | null;
  updateFilterDebounceFunction: any;
  lgaRefreshKey: number;
  tmpSearchInputs: any;
}

export default Vue.extend({
  name: 'FilterItems',
  components: {
    Slider: () =>
      import('@/components/Feasibility/Filters/Components/Slider.vue')
  },
  props: {
    headerText: {
      type: String,
      required: true
    },
    open: {
      type: Number,
      required: false,
      default: null
    },
    advanced: {
      type: Boolean,
      required: true
    }
  },
  data(): FilterListData {
    return {
      panel: null,
      updateFilterDebounceFunction: null,
      lgaRefreshKey: 0,
      tmpSearchInputs: {}
    } as FilterListData;
  },
  computed: {
    filterConfig(): any {
      return this.$store.direct.state.Filters.filterConfig;
    },
    filterConfigItems(): any {
      return this.filterConfig.filter((x) => {
        return x.advanced === this.advanced;
      });
    },
    scenario(): any {
      return this.$store.direct.state.Feasibility.scenario;
    }
  },
  mounted() {
    this.updateFilterDebounceFunction = utilMethods.debounce(
      this.updateFilter,
      1000
    );
    this.panel = this.open;
  },
  methods: {
    updateFilter(
      _event: any | null = null,
      _filterType: string | null = null
    ): void {
      this.$store.direct.commit.Filters.UPDATE_FILTER_CONFIG(this.filterConfig);
      this.$emit('applyFilters');
    },
    filterOptionsByActiveLga(filter: any): any[] {
      let newVals = [] as any[];
      if (filter.type == 'select_withLgaFilter') {
        if (filter.options && filter.options.length) {
          const filtersWithLgaGuids = filter.options.filter((x) => {
            return x.as_lga_guid;
          });
          if (filtersWithLgaGuids.length == 0) {
            //No options have LGA set - show full list
            newVals = filter.options;
          } else {
            newVals = filter.options.filter((x) => {
              if (this.scenario?.asLgaGuid) {
                return this.scenario?.asLgaGuid == x.as_lga_guid;
              } else {
                // Shown region wide only
                return !x.as_lga_guid;
              }
            });
          }
        }
      } else {
        newVals = filter.options;
      }
      return newVals;
    }
  }
});
